import { GenerateJwtResult } from '../models/genreteJwtResult';
import { IsAliveJwtResult } from '../models/isAliveJwtResult';
import Service from './service';

/**
 * 認証APIを操作するクラスです。
 */
class AuthService extends Service {
    /**
     * ログイン処理を行います。
     * @param accountName アカウント名を指定します。
     * @param password パスワードを指定します。
     * @returns ログインの結果を返します。
     */
    public async login(accountName: string, password: string) {
        let isLogin = false;
        const apiEndpoint = this.createApiEndpoint('generate_jwt')

        const params = {
            account_name: accountName,
            password: password,
        };

        try {
            const result = await this.httpPost<GenerateJwtResult>(apiEndpoint, params, null);

            if (result.jwt !== undefined) {
                sessionStorage.setItem('jwt', result.jwt);
                isLogin = true;
            }
        } catch (reson) {
            console.error(reson);
            throw new Error('login error');
        }

        return isLogin;
    };

    /**
     * ログアウトします。
     */
    public async logout() {
        await sessionStorage.removeItem('jwt');
    }

    /**
     * JWTが有効か確認します。
     * @returns JWTが有効ならtrue、無効ならfalseを返します。
     */
    public async isAliveJwt() {
        let isAlive = false;
        const jwt = this.getJwt();
        const apiEndpoint = this.createApiEndpoint('is_alive_jwt');

        const params = {
            jwt_str: jwt
        }

        const result = await this.httpPost<IsAliveJwtResult>(apiEndpoint, params, null);
        if (result.detail === 'is-alive-jwt:success') {
            isAlive = true;
        }

        return isAlive;
    }

    /**
     * ユーザーのJWTを取得します。
     * @returns 取得したJWTを返します。
     */
    public getUserJwt() {
        const jwt = this.getJwt();

        return jwt;
    }
}

export default AuthService;